import { Controller } from 'stimulus'
import * as basicLightbox from 'basiclightbox'

export default class extends Controller {
  static targets = ['overlay']

  initialize() {
    this._handleKeyDown = this.handleKeyDown.bind(this)
  }

  open() {
    this._lightbox.show()
  }

  close() {
    this._lightbox.close()
  }

  handleKeyDown(event) {
    if (event.keyCode === 27) {
      this.close()
    }
  }

  connect() {
    this._lightbox = basicLightbox.create(
      `<div class="embed-responsive embed-responsive-16by9">
        <iframe
          width="1280"
          height="720"
          src="https://www.youtube-nocookie.com/embed/${this.overlayTarget.getAttribute('data-youtube')}?modestbranding=1&rel=0"
          title="YouTube video player"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen>
        </iframe>
      </div>`
    )
    document.addEventListener('keydown', this._handleKeyDown)
  }

  disconnect() {
    document.removeEventListener('keydown', this._handleKeyDown)
  }
}
